<template>
  <q-card
    v-touch-repeat.mouse="event => $emit('touch-repeat', event)"
    class="column cursor-pointer"
    :class="(backgroundColor !== 'custom' ? 'bg-' + backgroundColor : '') + ' ' + (textColor !== 'custom' ? 'text-' + textColor : '')"
    :style="{
      'background-color': backgroundColor === 'custom' ? backgroundColorHex : '',
      'color': textColor === 'custom' ? textColorHex : ''
    }"
    flat
    bordered
  >
    <div>
      <transition
        leave-class="hidden"
        enter-active-class="animated bounceIn"
      >
        <q-badge
          v-if="count"
          style="font-size: 18px; z-index: 1"
          class="q-py-sm text-bold"
          color="primary"
          floating
        >
          x {{ count }}
        </q-badge>
      </transition>
    </div>

    <q-img
      :src="voucher.imageUrl || currentSite.voucherSaleImageUrl"
    >
      <div
        v-if="minimumAmount > 1"
        class="absolute-top-left text-subtitle2"
        style="padding: 2px 6px; background: none;"
      >
        Min. {{ minimumAmount }}
      </div>
    </q-img>
    <q-card-section class="column q-pa-xs">
      <div class="text-h6 text-center">
        {{ name || voucher.name }}
        <i18n-n
          :value="voucher.price"
          format="currency"
        />
      </div>
      <div
        v-if="voucher.description"
        class="text-caption text-center"
      >
        {{ voucher.description }}
      </div>
    </q-card-section>
  </q-card>
</template>

<script>
import VoucherPackage from 'src/models/voucher/VoucherPackage'
import VoucherType from 'src/models/voucher/VoucherType'

export default {
  name: 'VoucherCard',
  configuration: ['currentSite', 'currentCircuit', 'itemVariations'],
  props: {
    voucherType: {
      type: VoucherType,
      required: false,
      default: null
    },
    voucherPackage: {
      type: VoucherPackage,
      required: false,
      default: null
    },
    name: {
      type: String,
      required: false,
      default: ''
    },
    minimumAmount: {
      type: Number,
      required: false,
      default: 1
    },
    count: {
      type: Number,
      required: false,
      default: 0
    },
    backgroundColor: {
      type: String,
      required: false,
      default: 'default'
    },
    textColor: {
      type: String,
      required: false,
      default: 'default'
    },
    backgroundColorHex: {
      type: String,
      required: false,
      default: '#FFFFFF'
    },
    textColorHex: {
      type: String,
      required: false,
      default: '#000000'
    }
  },
  emits: ['touch-repeat'],
  computed: {
    voucher () {
      return this.voucherPackage || this.voucherType
    }
  }
}

</script>
